import liff from "@line/liff";
// import LIFFInspectorPlugin from "@line/liff-inspector";

document.addEventListener("DOMContentLoaded", () => {
  const myLiffId = gon.liff_id;

  // ローディング画面
  if ($(".loading-panel-wrap").length == 0) {
    $("body").append(
      "<div id='spinner-box' class='loading'><div class='circle-border'><div class='circle-core'></div></div></div>"
    );
  }

  // liff.use(new LIFFInspectorPlugin());
  liff
    .init({
      liffId: myLiffId,
    })
    .then(async () => {
      if (liff.isInClient()) {
        // LIFFブラウザ内で動作
        // const csrfToken = document
        //   .querySelector('meta[name="csrf-token"]')
        //   .getAttribute("content");
        //   idTokenSendToController(csrfToken);
      } else {
        // 外部ブラウザ内で動作
        if (liff.isLoggedIn()) {
          console.log("Logged in.");
        } else {
          liff.login();
        }
      }
    })
    .catch((err) => {
      document.getElementById("liffAppContent").classList.add("hidden");
      document.getElementById("liffErrorMessage").classList.remove("hidden");
    });

 // lineのユーザーIDトークンをcontrollerに送る
  // function idTokenSendToController(csrfToken) {
  //   alert("fefefefefefe")
  //   const idToken = liff.getIDToken();

  //   // let icon = iconForm.value;
  //   // if (icon === "undefined") {
  //   //   icon = "/user_default.png";
  //   // }
  //   const params = { idToken: idToken };
  //   const request = new Request("/sessions", {
  //     headers: {
  //       "Content-Type": "application/json; charset=utf-8",
  //       "X-CSRF-Token": csrfToken,
  //     },
  //     method: "POST",
  //     body: JSON.stringify(params),
  //   });
  //   fetch(request)
  //     .then((response) => response.json())
  //     .then((response) => {
  //       // if (response.error_messages) {
  //       //   submitBtn.textContent = "登録";
  //       //   submitBtn.disabled = false;
  //       //   $(".errors").empty();
  //       //   response.error_messages.forEach(function (error_message) {
  //       //     $(".errors").append(`
  //       //               <p class="error-messages">${error_message}</p>
  //       //             `);
  //       //   });
  //       // } else {
  //       //   // LIFFを閉じる
  //       //   closeWindow();
  //       // }
  //     })
  //     .catch((error) => {
  //       alert(error.message)
  //     });
  // }
});
